import React, { ComponentProps } from 'react';
import Div from '../../Element/Div/Div';

type CollapsibleBlockContentProps = {
  /** Contents shown inside */
  children: NonNullable<React.ReactNode>;
} & ComponentProps<typeof Div>;

const CollapsibleBlockContent: React.FunctionComponent<CollapsibleBlockContentProps> = ({
  children,
  padding = { horizontal: 'sm', vertical: 'sm' },
  ...props
}) => {
  return (
    <Div padding={padding} {...props}>
      {children}
    </Div>
  );
};

export default CollapsibleBlockContent;
